import _ from "lodash";
import { useMemo, useCallback } from "react";
import { useSelector } from "react-redux";
import { useQuery, useMutation, useQueryCache } from "react-query";
import { getUserPreferences, patchUserPreferences } from "../queries/userPreferences";
import networkSelectors from "../selectors/network";

interface IUserPreference {
  attributes: {
    key: string;
    value: string;
  };
}
export const useUserPreference = (key: string) => {
  const queryCache = useQueryCache();
  const networkHeaders = useSelector(networkSelectors.defaultHeaders);
  const userPreferencesQuery = useQuery(["userPreferences"], getUserPreferences(networkHeaders), {
    enabled: !!networkHeaders.Authorization,
  });
  const [updateUserPreferences] = useMutation(patchUserPreferences(networkHeaders), {
    onSuccess: () => queryCache.invalidateQueries("userPreferences"),
  });
  const update = useCallback(
    async (value: string) => {
      await updateUserPreferences({ key, value });
    },
    [key, updateUserPreferences],
  );
  const value = useMemo(() => {
    return _.get(
      _.get(userPreferencesQuery.data, "data", []).find(
        (preference: IUserPreference) => preference.attributes.key == key,
      ),
      "attributes.value",
    );
  }, [userPreferencesQuery.data]);

  return {
    value,
    update,
    query: userPreferencesQuery,
    isLoading: userPreferencesQuery.isLoading,
  };
};

export default useUserPreference;
